var scope_0 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1ef274f90f98011e797400a86ab11cdf.js').default;
var scope_1 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2f36a67c3fa0e7e73203323be077e981.js').default;
var scope_2 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/96b987ae6b3a9c78e00624c16b322056.js').default;
var scope_3 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d7eb85d9ffeda46d8eb21ceb60b07d81.js').default;
var scope_4 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_5 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ece3230814557199ff2d447cb1dfac75.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    